import { createPinia } from 'pinia';

export const mainPinia = createPinia();
